import { CssBaseline } from '@mui/material'
import { ThemeProvider } from '@mui/material/styles'
import { FC } from 'react'
import { useTenantIdAndPropertyId } from 'src/app/hooks/context/tenantIdAndPropertyId/tenantIdAndPropertyId.hook'
import useGetTheme from 'src/app/themes/use-get-theme'
import HiCLoading from 'src/app/components/HiCLoading'

export const BookingEngineLayout: FC = ({ children }) => {
  const { propertyId, tenantId } = useTenantIdAndPropertyId()

  const { loading, theme } = useGetTheme({ propertyId, tenantId })

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {loading && <HiCLoading />}
      {children}
    </ThemeProvider>
  )
}
